import { FC } from "react";
import classNames from "classnames";
import { ScanPageLeftCustomProps, ScanPageLeftItemEnum, } from "../../interface";
/** 自定义左侧表单 */
const Custom: FC<ScanPageLeftCustomProps> = props => {
  const { className, style, children, } = props;
  const classes = classNames('body-left-custom', className);
  return (
    <div className={classes} style={style}>{children}</div>
  );
};

Custom.displayName = ScanPageLeftItemEnum.Custom;

export default Custom;